module.exports = __webpack_public_path__ + "static/flags/KR-79292a34f2bc89f2d9f1326092ab24cb.gif";